import React from "react";
import "./fileUpload.css"
import { deleteIcon, fileUploadIcon } from "utils/constant";
interface MultipleFileUploadComponentProps {
  label?: string;
  acceptedFiles?: string;
  multiple?: boolean;
  maxFileSize?: number; // in MB
  uploadedFiles: File[];
  onFilesChange: (files: File[]) => void;
  className?: string;
  hint?: string;
  disabled?:boolean
}

export const MultipleFileUploadComponent: React.FC<MultipleFileUploadComponentProps> = ({
  label = "Attach Supporting Documents",
  acceptedFiles = ".pdf,.doc,.docx,.jpg,.png",
  multiple = true,
  maxFileSize = 10, // 10MB default
  uploadedFiles,
  onFilesChange,
  className = "",
  hint = "Supports PDF, DOC, JPG, PNG (Max 10MB each)",
  disabled
}) => {
  
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      
      // Validate file sizes
      const validFiles = newFiles.filter(file => file.size <= maxFileSize * 1024 * 1024);
      
      if (validFiles.length !== newFiles.length) {
        alert(`Some files exceed the maximum size of ${maxFileSize}MB`);
      }
      
      if (validFiles.length > 0) {
        const updatedFiles = multiple 
          ? [...uploadedFiles, ...validFiles]
          : validFiles;
        
        onFilesChange(updatedFiles);
        e.target.value = "";
      }
    }
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    onFilesChange(updatedFiles);
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileIcon = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    
    switch (extension) {
      case 'pdf':
        return (
          <svg className="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="black">
            <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/>
          </svg>
        );
      case 'doc':
      case 'docx':
        return (
          <svg className="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="black">
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg>
        );
      case 'jpg':
      case 'jpeg':
      case 'png':
        return (
          <svg className="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="black">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
          </svg>
        );
      default:
        return (
          <svg className="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="black">
            <path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>
          </svg>
        );
    }
  };

  return (
    <div className={`form-groupp ${className}`}>
      {label && (
        <label className="referral-form-label mt-2">
          {label}
        </label>
      )}
      
      <div className="upload-area bg-[#f2f2f2]">
        <input
          type="file"
          id="fileUpload"
          className="file-input"
          accept={acceptedFiles}
          multiple={multiple}
          onChange={handleFileSelect}
          disabled={disabled}
        />
        <label htmlFor="fileUpload" className="upload-label">
          {fileUploadIcon}
          <p className="upload-text">
            Drag & drop files here or click to browse
          </p>
          <p className="upload-hint">
            {hint}
          </p>
        </label>
      </div>

      {uploadedFiles.length > 0 && (
        <div className="uploaded-files-list" style={{zIndex:"1000"}}>
          {uploadedFiles.map((file, index) => (
            <div key={`${file.name}-${index}`} className="uploaded-file-item">
              <div className="file-info">
                <div className="file-icon">
                  {getFileIcon(file.name)}
                </div>
                <div>
                  <span className="file-name">{file.name}</span>
                  <span className="file-size">
                    {formatFileSize(file.size)}
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="remove-file-button" style={{background:"transparent",width:"fit-content"}}
                onClick={() => handleRemoveFile(index)}
              >
                {deleteIcon}
              </button>
            </div>
          ))}
         
        </div>
      )}
  
    </div>
  );
};